module.exports = __webpack_public_path__ + "img/filter-bedrooms.baf4c7bb.svg";